/**
 * Mounts hero Media slide blocks (rendered via content_for 'blocks' in the content
 * wrapper) into the hero background slideshow scroller.
 */
function mountHeroMediaSlides() {
  document.querySelectorAll('slideshow-component[data-hero-slideshow]').forEach((slideshow) => {
    const hero = slideshow.closest('.hero');
    if (!hero) return;

    const scroller = slideshow.querySelector('slideshow-slides');
    const contentWrapper = hero.querySelector('.hero__content-wrapper');
    if (!scroller || !contentWrapper) return;

    const slides = [...contentWrapper.querySelectorAll(':scope > slideshow-slide')];
    if (!slides.length) return;

    slides.forEach((slide) => scroller.append(slide));

    if (typeof slideshow.updatedCallback === 'function') {
      slideshow.updatedCallback();
    }

    const initialSlide = parseInt(slideshow.getAttribute('initial-slide') || '0', 10) || 0;
    const slideId = slides[initialSlide]?.getAttribute('slide-id');
    if (slideId && typeof slideshow.select === 'function') {
      slideshow.select({ id: slideId }, undefined, { animate: false });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountHeroMediaSlides);
} else {
  mountHeroMediaSlides();
}

document.addEventListener('shopify:section:load', mountHeroMediaSlides);
